var map = {
	"./BenX.jpg": 1486,
	"./Burberry.png": 414,
	"./Caretta.png": 735,
	"./Dolce Gabbana.png": 4732,
	"./Eschbah.png": 3453,
	"./Fineline.png": 3273,
	"./Fisher Price.png": 8063,
	"./Furla.png": 1221,
	"./Goldberry.png": 1245,
	"./Guess.png": 8336,
	"./Hawk.jpg": 124,
	"./Humphreys.png": 2546,
	"./Just Cavalli.png": 6373,
	"./Lacoste.png": 1572,
	"./Miu Miu.png": 959,
	"./Mustang.png": 90,
	"./Oakley.png": 1004,
	"./Osse.png": 6369,
	"./Persol.png": 6226,
	"./Police.png": 5517,
	"./Prada.png": 6237,
	"./Rayban.PNG": 919,
	"./Rococo.jpg": 1854,
	"./Titanflex.png": 5032,
	"./Tom Ford.jpg": 1484,
	"./Versace.png": 1564,
	"./Vogue.png": 1189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6148;